import { useDeleteCompany } from "http-hooks/company/useCompany";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteCompany({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteCompany();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast is already handled by the service
      console.error("Delete company error:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Company"
      description="Are you sure you want to delete this Company? This Company will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}

